export class DtoTicketUse {
  dateTime: string;
  direction: string;

  constructor(dateTime: string, direction: string) {
    this.dateTime = dateTime;
    this.direction = direction;
  }
}
